import React from "react"
import "./Synonyms.css"

export default function Synonyms(props){
    if(props.synonyms){
        return (
            <ul className="Synonyms">
                {props.synonyms.map(function(synonyms, index){
                    return(
                        <ul className="list"><li key={index}>{synonyms}</li></ul>   
                    )
                })}
            </ul>
        )
    }else{
        return  null
    }
}